export const searchFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 3,
    backgroundColor: 'white',
    height: 40,
    alignItems: 'center',
    boxShadow: 'none',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#D7DDEA',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#C8D0E0',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#BFC8DA',
    },
  },
  '& .MuiInputAdornment-root': {
    color: '#8A90A4',
  },
  '& .MuiOutlinedInput-input': {
    fontSize: 14,
    lineHeight: 1.35,
    color: '#203864',
  },
  '& .MuiOutlinedInput-input::placeholder': {
    fontSize: 14,
    opacity: 1,
    fontWeight: 400,
    lineHeight: 1.35,
    color: '#9AA3B5',
  },
}
